<template>
  <div>
    <v-alert
      v-if="instruction"
      border="left"
      colored-border
      color="red"
      class="text-body-2 grey lighten-4 pl-5"
    >
      <div class="font-weight-bold">
        <s-name-tooltip
          :name="senderName"
          :euid="senderEuid"
        />
        {{ $t('eDocSuggest.instructionOf') }}：
      </div>
      <div style="white-space: pre-line;">
        {{ instruction }}
      </div>
    </v-alert>

    <v-alert
      v-if="prefillInfo && (prefillInfo.prefilledInstruction || typeof prefillInfo === 'string' || prefillInfo.preFilledReceiverTOList.length)"
      border="left"
      colored-border
      color="light-blue"
      class="text-body-2 grey lighten-4 pl-5"
    >
      <div
        class="font-weight-bold"
      >
        <s-name-tooltip
          :name="senderName"
          :euid="senderEuid"
        />
        {{ $t('eDocInternal.handleMethodSuggestion') }}
      </div>
      <div>
        <template v-if="typeof prefillInfo === 'string'">
          <div style="white-space: pre-line;">
            {{ prefillInfo }}
          </div>
        </template>
        <template v-else>
          <div style="white-space: pre-line;">
            {{ prefillInfo.prefilledInstruction }}
          </div>
          <div>
            {{ $t('eDocSuggest.history.receiver') }}:
            <span
              v-for="(item) in prefillInfo.preFilledReceiverTOList"
              :key="item.id"
            >
              <template v-if="item.chinName || item.portName">{{ $chPtObjData('chinName', item) }} <v-space /></template>
              <template v-else>{{ $chPtObjData('chinGroupName', item) }} <v-space /></template>
            </span>
          </div>
        </template>
      </div>
    </v-alert>

    <v-alert
      v-if="senderNote"
      border="left"
      colored-border
      color="yellow"
      class="text-body-2 grey lighten-4 pl-5"
    >
      <div class="font-weight-bold">
        <s-name-tooltip
          :name="senderName"
          :euid="senderEuid"
        />
        {{ $t('eDocSuggest.privateMsgToMe') }}：
      </div>
      <div style="white-space: pre-line;">
        {{ senderNote }}
      </div>
    </v-alert>
  </div>
</template>

<script>
import SNameTooltip from '@/components/SNameTooltip.vue'

export default {
  components: {
    SNameTooltip
  },
  props: {
    task: {
      type: Object,
      default: null
    },
    instruction: {
      type: String,
      default: null
    },
    prefillInfo: {
      type: [Object, String],
      default: null
    },
    senderNote: {
      type: String,
      default: null
    },
    senderName: {
      type: String,
      default: null
    },
    senderEuid: {
      type: String,
      default: null
    }
  }
}
</script>
